import { AmChartsService } from '@amcharts/amcharts3-angular';
import { SurvivalHorizonService } from './../../survival-horizon/survival-horizon.service';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { MetricSelection } from './../metric-selection';
import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ThroughputMetric } from './throughput-metric';
import { TrendMetric } from './../trend-metric/trend-metric';

@Component({
    selector: 'app-throughput-metric',
    templateUrl: './throughput-metric.component.html',
    styleUrls: ['./throughput-metric.component.scss', './../trend-metric/trend-metric.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThroughputMetricComponent implements OnInit, OnDestroy {
    @Input()
    throughputMetric: ThroughputMetric;

    constructor(private amCharts: AmChartsService,
        private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private changeDetectorRef: ChangeDetectorRef) {

    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.changeDetectorRef.detach();
    }

    refreshMetric() {
        this.changeDetectorRef.markForCheck();
    }

    onHistory() {
        this.dashboardEventService.metricSelectionSubject.next(
             new MetricSelection(
                 'HISTORY',
                 this.throughputMetric.currency,
                 this.throughputMetric.metricType,
                 this.throughputMetric.name,
                 this.throughputMetric
        ));
    }

    onIntraday() {
        this.dashboardEventService.metricSelectionSubject.next(
            new MetricSelection('THROUGHPUT', this.throughputMetric.currency,
                this.throughputMetric.metricType, this.throughputMetric.name)
        );
    }

    lightMetricColor(throughputMetric: ThroughputMetric) {
        if (throughputMetric.initialized) {
            const index = Math.round(
                (Math.min(throughputMetric.actualPayPercentage, throughputMetric.actualRecPercentage) * TrendMetric.C_900.length));
            return TrendMetric.C_900[Math.min(index, TrendMetric.C_900.length - 1)];
        }
    }
}
